import { FileSubType, ResourceType } from '@models';

export const getPathByType = (type: ResourceType | 'TEMPLATE') => {
  const typeMap: Record<ResourceType | 'TEMPLATE', string> = {
    [ResourceType.COMMUNITY]: 'community',
    [ResourceType.USER]: 'users',
    [ResourceType.GROUP]: 'groups',
    [ResourceType.ROOM]: 'rooms',
    [ResourceType.FILE]: 'files',
    [ResourceType.DISCUSSION]: 'discussions',
    [ResourceType.EVENT]: 'events',
    [ResourceType.VOTING]: 'votings',
    [ResourceType.REQUEST]: 'requests',
    [ResourceType.AGENDA_POINT]: 'agendapoints',
    [ResourceType.ACTIVITY]: 'activities',
    [ResourceType.CONVERSATION]: 'conversations',
    TEMPLATE: 'community/templates',
  };

  return typeMap[type];
};

export const getResourceTypeUrl = (type: ResourceType) => {
  if (type === ResourceType.USER) {
    return 'users';
  } else if (type === ResourceType.GROUP) {
    return 'groups';
  } else if (type === ResourceType.FILE) {
    return 'files';
  } else if (type === ResourceType.COMMUNITY) {
    return 'community';
  } else if (type === ResourceType.DISCUSSION) {
    return 'discussions';
  } else if (type === ResourceType.EVENT) {
    return 'events';
  } else if (type === ResourceType.AGENDA_POINT) {
    return 'agendapoints';
  }

  return 'rooms';
};

export const getResourceTypeByList = (
  list: { type: ResourceType; subtype?: number }[]
) => {
  const match = (type: ResourceType, subtype?: number) =>
    list.every(
      (el) =>
        el.type === type && (subtype === undefined || el.subtype === subtype)
    );

  if (match(ResourceType.FILE, FileSubType.FILE_SHORTCUT)) {
    return 53;
  }

  if (match(ResourceType.FILE)) {
    return ResourceType.FILE;
  }

  if (match(ResourceType.ROOM)) {
    return ResourceType.ROOM;
  }

  if (match(ResourceType.DISCUSSION)) {
    return ResourceType.DISCUSSION;
  }

  if (match(ResourceType.EVENT)) {
    return ResourceType.EVENT;
  }

  if (match(ResourceType.VOTING)) {
    return ResourceType.VOTING;
  }

  if (match(ResourceType.AGENDA_POINT)) {
    return ResourceType.AGENDA_POINT;
  }

  if (match(ResourceType.USER)) {
    return ResourceType.USER;
  }

  if (match(ResourceType.GROUP)) {
    return ResourceType.GROUP;
  }

  return null;
};
